import script from "./Platform365MarketplaceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./Platform365MarketplaceDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__